import styled from 'styled-components';

export const BandWorkspace = styled.section`
  width: 100%; min-width: 0; max-width: 1120px; margin: 0 auto; padding: 16px 20px;
  h1 { font-size: 1.8rem; }
  h2 { font-size: 1.35rem; margin: 12px 0; }
  h3 { font-size: 1.05rem; }
  p, a, label { overflow-wrap: anywhere; }
  input, select, button { font: inherit; }
  input:not([type='checkbox']), select {
    min-width: 0; width: 100%; padding: 10px; min-height: 44px;
    border: 1px solid var(--line-strong); border-radius: 6px;
    color: var(--text); background: var(--surface);
  }
  input[type='checkbox'] { width: 20px; height: 20px; flex-shrink: 0; }
  button, .action {
    display: inline-flex; align-items: center; justify-content: center;
    min-height: 44px; padding: 8px 14px; border-radius: 6px;
    background: var(--accent); color: white; text-decoration: none;
  }
  button:disabled { opacity: 0.55; cursor: default; }
  .error { color: #a12121; }
  .muted { color: var(--muted); font-size: 0.9rem; }
`;
export const BandToolbar = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin: 16px 0;
  form { display: flex; flex: 1; flex-wrap: wrap; align-items: end; gap: 10px; }
  label { flex: 1; min-width: min(220px, 100%); }
`;
export const BandTabs = styled.nav`
  display: flex; flex-wrap: wrap; gap: 6px; border-bottom: 1px solid var(--line); padding-bottom: 10px;
  a { padding: 10px 14px; color: var(--text); text-decoration: none; border-bottom: 3px solid transparent; }
  a[aria-current='page'] { border-color: var(--accent); font-weight: 700; }
`;
export const BandList = styled.ul`
  list-style: none; margin: 0; padding: 0;
  li { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 16px 0; border-bottom: 1px solid var(--line); }
  .details { flex: 1; min-width: min(220px, 100%); overflow-wrap: anywhere; }
  .details p { margin: 4px 0 0; }
`;
